import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex flex-col items-center justify-center ${className}`} data-id="element-255">
      <svg width="48" height="32" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-256">
        {/* Roof */}
        <path d="M50 5 L10 35 L18 40 L50 15 L82 40 L90 35 Z" fill="#0a1e5e" data-id="element-257" />
        {/* Chimney */}
        <rect x="70" y="10" width="8" height="20" fill="#0a1e5e" data-id="element-258" />
        {/* House Body */}
        <rect x="25" y="25" width="50" height="30" fill="#0a1e5e" data-id="element-259" />
        {/* Window */}
        <rect x="40" y="35" width="8" height="8" fill="white" data-id="element-260" />
        <rect x="52" y="35" width="8" height="8" fill="white" data-id="element-261" />
      </svg>
      <div className="text-[#0a1e5e] font-black tracking-tighter text-xs mt-1 leading-none" data-id="element-262">
        MORTGAGE
      </div>
      <div className="text-[#0a1e5e] font-bold tracking-widest text-[9px] leading-none flex items-center gap-1 mt-0.5" data-id="element-263">
        <span className="w-3 h-[1px] bg-[#0a1e5e]" data-id="element-264"></span>
        DEPOT
        <span className="w-3 h-[1px] bg-[#0a1e5e]" data-id="element-265"></span>
      </div>
    </div>;
}